<template>
  <section class="reports-income-tabs" aria-label="Secciones principales de reportes">
    <button
      v-for="tab in normalizedTabs"
      :key="tab.key"
      type="button"
      class="reports-income-tab"
      :class="{ active: activeTab === tab.key }"
      @click="selectTab(tab.key)"
    >
      <span class="reports-income-tab__title">{{ tab.label }}</span>
      <small v-if="tab.description" class="reports-income-tab__description">{{ tab.description }}</small>
    </button>
  </section>
</template>

<script>
export default {
  name: 'ReportsPrimaryTabs',
  props: {
    tabs: {
      type: Array,
      default: () => [],
    },
    activeTab: {
      type: String,
      default: '',
    },
  },
  emits: ['select'],
  computed: {
    normalizedTabs() {
      return (Array.isArray(this.tabs) ? this.tabs : []).filter((tab) => {
        return tab && typeof tab === 'object' && String(tab.key || '').trim() !== '';
      });
    },
  },
  methods: {
    selectTab(tabKey) {
      const normalizedKey = String(tabKey || '').trim();
      if (normalizedKey === '' || normalizedKey === this.activeTab) {
        return;
      }

      this.$emit('select', normalizedKey);
    },
  },
};
</script>
